export function ConfirmUserActionDialog({
  title,
  description,
  actionLabel,
  tone = 'primary',
  busy,
  error,
  onClose,
  onConfirm,
}: {
  title: string;
  description: string;
  actionLabel: string;
  tone?: 'primary' | 'danger';
  busy: boolean;
  error: string | null;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <div className="r42-dialog-layer" role="dialog" aria-modal="true" aria-labelledby="confirm-user-action-title">
      <button className="r42-dialog-backdrop" aria-label="Close confirmation" onClick={busy ? undefined : onClose} />
      <div className="r42-dialog-card r42-user-dialog">
        <span className="r42-eyebrow">Users & access</span>
        <h2 id="confirm-user-action-title">{title}</h2>
        <p>{description}</p>
        {error ? <div className="r42-form-alert" role="alert"><i className="bi bi-exclamation-circle" aria-hidden="true" /><div><strong>Route42 could not complete this change.</strong><span>{error}</span></div></div> : null}
        <div className="r42-dialog-actions">
          <button type="button" className="btn btn-outline-secondary" onClick={onClose} disabled={busy}>Cancel</button>
          <button type="button" className={`btn ${tone === 'danger' ? 'btn-danger' : 'r42-btn-primary'}`} onClick={onConfirm} disabled={busy}>
            {busy ? <><span className="spinner-border spinner-border-sm" aria-hidden="true" /> Working…</> : actionLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
